<template>
  <div style="background: #17171a">
    <SiteHead/>
    <div>
      <div class="verification-main">
        <div class="verification-main-header">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-daiwenzilogo"></use>
          </svg>
          <!--官方验证通道-->
          <h1 class="bold">{{$t('8100013')}}</h1>
        </div>
        <div class="verification-main-search flex-between">
          <!--请输入需要验证的信息-->
          <i class="iconfont icon-search bold"></i>&nbsp;
          <van-field type="text" :placeholder="$t('8100014')" v-model="keyWord" maxlength="150" clearable></van-field>
          <van-button class="form-btn" :loading="buttonLoading" :disabled="keyWord === ''" @click="handleCheck">{{$t('300143')}}</van-button>
        </div>
        <div class="verification-main-content">
          <!--您可以进行如下内容的验证-->
          <p class="bold title">{{$t('8100015')}}</p>
          <ul type="none">
            <li>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-a-material_1svg"></use>
              </svg>
              <div class="content-text">
                <p class="bold">{{$t('300144')}}</p>
                <span class="block">{{$t('8100016')}}</span>
              </div>
            </li>
            <li>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-a-material_2svg"></use>
              </svg>
              <div class="content-text">
                <p class="bold">{{$t('8100017')}}</p>
                <span class="block">{{$t('8100018')}}</span>
              </div>
            </li>
            <li>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-a-material_3svgfill"></use>
              </svg>
              <div class="content-text">
                <p class="bold">{{$t('8100019')}}</p>
                <span class="block">{{$t('8100020')}}</span>
              </div>
            </li>
          </ul>
        </div>
        <p v-html="$t('8100021')" class="verification-main-tips"></p>
      </div>
      <SiteMap/>
    </div>
    <SiteFoot/>
    <van-popup v-model="resultModel">
      <div class="result-model" v-if="resultObj">
        <p class="bold model-title flex-center">
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="resultObj.code != 200 ? '#icon-shibai1' : '#icon-chenggong'"></use>
          </svg>&nbsp;&nbsp;{{resultObj.code != 200 ? $t('8100022') : $t('8100023')}}</p>
        <span class="block model-res-message" v-html="$t('8100024',{keyWord: keyWord})" v-if="resultObj.code != 200"></span>
        <span class="block model-res-message" v-html="$t('8100025',{keyWord: keyWord,note:resultObj.data})" v-else></span>
        <div class="safety-tips">
          <p><i class="iconfont icon-tishi"></i>&nbsp;&nbsp;{{$t('8100026')}}</p>
          <span class="block">{{$t('8100027')}}</span>
          <span class="block">{{$t('8100028')}}</span>
          <span class="block">{{$t('8100029')}}</span>
        </div>
        <van-button class="form-btn" @click="resultModel = false;">{{$t('10000018')}}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SiteHead from '../compontents/newHome/SiteHead.vue'
import SiteMap from '../compontents/newHome/SiteMap.vue'
import SiteFoot from '../compontents/newHome/SiteFoot.vue'
import {Button, Popup,Field} from "vant";
import {mapGetters} from "vuex";
import {verificationApi} from "../api/resource";

export default {
  name: "verification",
  components: {SiteFoot, SiteHead, SiteMap,
    vanButton:Button,
    vanPopup:Popup,
    vanField:Field
  },
  data() {
    return {
      keyWord: '',
      resultModel: false,
      resultObj: null,
      buttonLoading: false
    }
  },
  computed: {
    ...mapGetters(['isDirection','token'])
  },
  created() {
    window.document.documentElement.setAttribute("dir", this.isDirection ? 'rtl' : 'ltr');
  },
  methods: {
    handleCheck() {
      posthog.capture('Button Clicked', {
        trigger:'h5_official_verification_page_query_button',
        name:'官方验证通道页面-查询按钮-H5'
      });
      this.buttonLoading = true
      verificationApi({account: this.keyWord}).then(res => {
        this.resultObj = res
        this.buttonLoading = false
        this.resultModel = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";
.verification-main{
  width: 100vw;
  padding-top: torem(75);
  background: url("../assets/images/Spotlight.png") no-repeat;
  background-size: 100% 100%;
  height: auto;
  &-header{
    text-align: center;
    margin-bottom: torem(37);
    svg{
      width: torem(144);
      height: torem(27);
      margin: 0 auto torem(20);
    }
    h1{
      font-size: torem(38);
      color: #FFFFFF;
      margin: 0;
      line-height: 1;
    }
  }
  &-search{
    margin: 0 auto torem(35);
    width: torem(325);
    height: torem(40);
    border: torem(2) solid rgba(255, 255, 255, 0.3);
    padding: torem(5);
    border-radius: torem(38);
    i{
      @include sc(torem(16),rgba(255, 255, 255, 0.3));
      margin-top: torem(2);
    }
    /deep/ .van-cell{
      width: calc(100% - #{torem(115)});
      background: transparent;
      padding: torem(5) torem(2);
      i{
        @include sc(torem(14),rgba(255, 255, 255, 0.3));
      }
    }
    /deep/ .van-field__control{
      @include sc(torem(14),#FFFFFF);
    }
    /deep/ .van-cell::after{
      border: none;
    }
    input::placeholder{
      @include sc(torem(14),rgba(255, 255, 255, 0.3))
    }
    .form-btn{
      width: torem(90);
      height: torem(29);
      border-radius: torem(30);
      font-size: torem(14);
      line-height: 1;
      background-color: #FFC72B;
      border: none;
    }
    /deep/ .van-button--disabled{
      background-color: rgba(255, 255, 255, 0.3);
      color: rgba(255, 255, 255, 0.5);
      opacity: 1;
    }
  }
  &-content{
    width: 100%;
    margin: 0 auto torem(44);
    text-align: center;
    p.title{
      @include sc(torem(16),#FFFFFF);
      margin-bottom: torem(26);
    }
    ul{
      li{
        width: torem(325);
        height: auto;
        padding: torem(16);
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border-radius: torem(8);
        border: torem(1) solid rgba(255, 255, 255, 0.17);
        background: rgba(255, 255, 255, 0.05);
        margin: 0 auto torem(16);
        svg{
          width: torem(32);
          height: torem(32);
        }
        .content-text{
          width: calc(100% - #{torem(42)});
          text-align: start;
          p{
            @include sc(torem(16),#FFFFFF);
            margin-bottom: torem(10);
            line-height: 1.1;
          }
          span.block{
            @include sc(torem(14),rgba(255, 255, 255, 0.7));
            line-height: 1.2;
          }
        }
      }
    }
  }
  &-tips{
    padding: torem(0) torem(20);
    margin: 0 auto torem(30);
    @include sc(torem(13), #FFFFFF);
    text-align: center;
    line-height: 1.5;
  }
}
/deep/ .van-popup{
  background: transparent;
}
.result-model{
  width: torem(345);
  height: auto;
  border-radius: torem(8);
  background-color: #2E2F35;
  padding: torem(32) torem(18) torem(32);
  p.model-title{
    @include sc(torem(16), #FFFFFF);
    margin-bottom: torem(18);
    svg{
      width: torem(18);
      height: torem(18);
    }
  }
  span.model-res-message{
    @include sc(torem(12), #FFFFFF);
    line-height: 1.5;
    margin-bottom: torem(18);
  }
  .safety-tips{
    width: 100%;
    height: auto;
    border: torem(1.5) solid #FFC72B;
    border-radius: torem(4);
    padding: torem(10);
    margin-bottom: torem(20);
    background: rgba(255, 199, 43, 0.1);
    p{
      @include sc(torem(12), rgba(255, 255, 255, 0.80));
      line-height: 1.5;
      margin-bottom: torem(4);
      i{
        @include sc(torem(12), #F1B90A);
        vertical-align: middle;
      }
    }
    span{
      margin: 0 torem(8);
      @include sc(torem(12), rgba(255, 255, 255, 0.50));
      line-height: 1.5;
      text-indent: torem(-8);
      letter-spacing: torem(0.5);
    }
  }
  .form-btn{
    width: 100%;
    height: torem(42);
    line-height: torem(42);
    padding: 0;
    font-size: torem(15);
    color: #000922;
    background-color: #FFC72B;
    text-align: center;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/verification.vue